/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Divider, LinearProgress } from '@mui/material';

import { LayoutBase } from '../../../../../layouts';
import { AccordionInstruments, ToolsDamInformation } from '../../../../../components/custom';
import { VMenu } from '../../../../../components/shared';
import { useParams } from 'react-router-dom';
import { IReadingsInstruments, ReadingServices } from '../../../../../services/api/reading/ReadingServices';
import { useEffect, useState } from 'react';

export const OperationRecords = () => {

    const { id } = useParams();

    const [dataInstrument, setDataInstrument] = useState<IReadingsInstruments[]>([]);

    useEffect(() => {
        fetchData();
    }, [id]);

    const fetchData = () => {
        if (id !== undefined && id !== 'novo') {
            ReadingServices.getAll(id)
                .then((response) => {
                    if (response instanceof Error) {
                        setDataInstrument([]);
                    } else {
                        const cleanedData = response.filter(item => item !== null && item !== undefined);
                        setDataInstrument(cleanedData);
                    }
                })
                .catch(error => {
                    setDataInstrument([]);
                });
        } else {
            setDataInstrument([]);
        }
    };


    function ValuesByInstrument(data: IReadingsInstruments[], type: string): IReadingsInstruments[] {
        if (!data || !Array.isArray(data)) {
            return [];
        }
        const value = data.filter(index => index && index.tipo_instrumento === type);
        return value;
    }

    return (
        <LayoutBase
            title='Registros de Operações'
            tollBar={
                <ToolsDamInformation />
            }
        >
            <Box width={'100%'}>
                <VMenu id={id} />
                <Divider />

                <Box padding={2} display={'flex'} flexDirection={'column'} gap={2}>
                    {dataInstrument.length > 0 ? (
                        <>
                            <AccordionInstruments key={'piezometro'}
                                data={ValuesByInstrument(dataInstrument, 'piezometro')}
                                type='Piezometro'
                                titulo='Piezômetro'
                            />
                            <AccordionInstruments key={'indicador'}
                                data={ValuesByInstrument(dataInstrument, 'indicador')}
                                type='Indicador'
                                titulo='Indicador NA'
                            />
                            <AccordionInstruments
                                data={ValuesByInstrument(dataInstrument, 'pluviometro')}
                                type='Pluviômetro'
                                titulo='Pluviômetro'
                            />
                            <AccordionInstruments
                                data={ValuesByInstrument(dataInstrument, 'regua')}
                                type='Regua'
                                titulo='Régua'
                            />
                            <AccordionInstruments
                                data={ValuesByInstrument(dataInstrument, 're')}
                                type='Re'
                                titulo='Ré Topografica'
                            />
                            <AccordionInstruments
                                data={ValuesByInstrument(dataInstrument, 'marco')}
                                type='Marco'
                                titulo='Marco'
                            />
                            <AccordionInstruments
                                data={ValuesByInstrument(dataInstrument, 'inclinometro')}
                                type='Inclinometro'
                                titulo='Inclinômetro'
                            />
                            <AccordionInstruments
                                data={ValuesByInstrument(dataInstrument, 'vazao')}
                                type='vazao'
                                titulo='Medidor de Vazão'
                            />
                        </>
                    ) : (
                        <LinearProgress />
                    )}
                </Box>
            </Box>
        </LayoutBase>
    );
};